<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M42.1 15H28.2c-.2 0-.4.2-.4.4v2.1c0 .3-.2.6-.5.6h-6.5c-.3 0-.5-.2-.5-.6v-2.1c0-.2-.2-.4-.4-.4h-14c-.5 0-.9.4-.9.9V39c0 2.2 1.8 4 4 4h30c2.2 0 4-1.8 4-4V15.9c0-.5-.4-.9-.9-.9zM31.9 37.3c-.2.8-.8 1.4-1.6 1.6-.8.2-1.6 0-2.2-.6l-3.9-3.9c-2.2.9-4.8.5-6.5-1.3-1.8-1.8-2.2-4.3-1.3-6.5l3.5 3.5L23 27l-3.5-3.5c2.2-.9 4.7-.5 6.5 1.3 1.8 1.8 2.2 4.3 1.3 6.5l3.9 3.9c.7.5.9 1.3.7 2.1zM20.3 5h-9c-.3 0-.7.1-.8.4l-4.2 5.7c-.2.5.1.7.5.7h12.7c.3 0 .5-.2.5-.5l.7-5.7c.2-.4-.1-.6-.4-.6zm21.4 6.1-4.1-5.7c-.2-.3-.6-.4-.8-.4h-9c-.3 0-.5.2-.5.5l.7 5.7c0 .3.2.5.5.5h12.7c.4.1.7-.1.5-.6z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
